import { useContext, useMemo } from "react";

import { DataContext } from "contexts/Data";
import { findColor } from "helpers/variant";

import type { ColorOption } from "types/app";

/**
 * Only use this hook under DataContext
 */
export default function useSelectedColor(): ColorOption | undefined {
  const { configuration, cachedState } = useContext(DataContext);

  return useMemo(() => {
    if (!configuration || !cachedState.colorId) return;

    return findColor(configuration.colors, cachedState.colorId);
  }, [configuration, cachedState.colorId]);
}
